import type { ApiOtpReference, ApiUserLoginPayload } from 'src/types/userAuth';

import { useMutation } from '@tanstack/react-query';

import axios from 'src/utils/axios';

/**
 * POST /user/auth/login — starts an email (account) login: emails an OTP and returns its
 * reference. Unlike `useRegister`, it never creates an account; an unknown email gets an
 * identical reference stub with no code sent (anti-enumeration, api PR1). This is the clean
 * "sign in" entry — a brand-new visitor is routed to /plans to register with a plan instead.
 */
export const useUserLogin = () =>
  useMutation({
    mutationFn: async (payload: ApiUserLoginPayload): Promise<ApiOtpReference> => {
      const response = await axios.post<ApiOtpReference>(`/user/auth/login`, payload);
      return response.data;
    },
  });
